export const drawerWidth = 60;
export const innerDrawerWidth = 200;
export const sumDrawers = drawerWidth + innerDrawerWidth + 2;
